/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { filterAction, getInvoiceAction } from "../../../redux/actions/paymentsActions";
import { LoadableContainer } from "./../../../widgets";
import { getCurrencySign } from '../../../utils';
import PaymentModal from '../common/PaymentModal';
import CustomizableTable from '../../../common/table/customizableTable';
import { PAGINATION_OPTIONS, getPublishersPayoutsColumns } from '../../../constants/payouts';

class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    const user = props.user;
    this.state = {
      currentPayment: {},
      payment_type: user.payment_type || '',
      balance: 'Balance',
      payment_method: '',
      payment_amount: '',
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.renderRowColor = this.renderRowColor.bind(this);
    this.downloadInvoice = this.downloadInvoice.bind(this);
    this._renderColumns = this._renderColumns.bind(this);
  }

  showModal(payment) {
    this.setState({
      showModal: true,
      currentPayment: { ...payment }
    });
  }

  hideModal() {
    this.setState({
      showModal: false,
    });
  }

  downloadInvoice(data) {
    const { getInvoicePdf } = this.props;
    const invoiceId = data.id;
    getInvoicePdf(invoiceId)
      .then((response) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);
      });
  }

  _renderColumns() {
    const {
      user,
      settings,
    } = this.props;
    const currencySign = getCurrencySign(user);
    return [
      ...getPublishersPayoutsColumns(
        currencySign,
        {
          user: user,
          usersSettings: settings,
        },
        {
          showModal: this.showModal,
          downloadInvoice: this.downloadInvoice,
        }
      ),
    ];
  }

  renderRowColor(row) {
    let rowColor = '';
    const index  = row.index|| row.viewIndex;
    if (index % 2 === 0) {
      rowColor = 'custom-odd';
    } else {
      rowColor = 'custom-even';
    }
    return rowColor;
  };

  render() {
    const {
      payments,
      filters,
      loading,
      loaded,
      total,
      onPaginationLoad,
      _filterAction,
    } = this.props;
    const {
      showModal,
      currentPayment,
    } = this.state;

    const pageSize = PAGINATION_OPTIONS[1].value;
    const isPaginationRequired = (total > pageSize);
    const items = payments || [];

    return (
      <>
        <LoadableContainer
          loading={false}
          loaded={loaded}
          style={{
            position: 'relative',
            width: '100%',
            maxHeight: '350px',
          }}
        >
          <CustomizableTable
            sortable={false}
            className='custom-data-offer-table'
            columns={this._renderColumns()}
            sourceName="publisher_postbacks"
            keyField="id"
            data={items}
            defaultSortDesc={false}
            minRows={3}
            pageSize={isPaginationRequired ? pageSize : items.length}
            pages={isPaginationRequired ? Math.ceil(total / pageSize) : 0}
            showPagination={isPaginationRequired}
            showPaginationTop={false}
            showPaginationBottom={isPaginationRequired}
            showPageSizeOptions={false}
            manual={isPaginationRequired}
            pageSizeOptions={[pageSize]}
            onPageChange={(page) => {
              if (isPaginationRequired) {
                filters.page = page + 1;
                _filterAction(filters);
                onPaginationLoad();
              }
            }}
            style={{
              maxHeight: '100%',
              borderLeft: 0,
              borderRight: 0,
              borderBottom: 0,
              width: '100%',
            }}
            customDragDropColumnsClass={'min-drag-drop-context-container'}
            loading={loading}
            getTrProps={(state, row, column, instance) => ({
              className: (row && row.original && this.renderRowColor(row)),
            })}
          />
        </LoadableContainer>
        {showModal && (
          <PaymentModal
            showModal={showModal}
            currentPayment={currentPayment}
            hideModal={this.hideModal}
          />
        )}
      </>
    );
  }
}

PaymentHistory.defaultProps = {
  payments: [],
  total: 0,
  filters: {},
  _filterAction: () => null,
  getInvoicePdf: (_id) => null,
  onPaginationLoad: () => null,
};

const mapStateToProps = (state) => ({
  user: state.users.currentUser || {},
  users: state.users,
  settings:  state.users.settings || {},
  filters: state.payments.filters,
  payments: state.payments.items,
  total: state.payments.total,
  loading: state.payments.loading,
  loaded: state.payments.loaded,
})

const mapDispatchToProps = (dispatch) => ({
  _filterAction: (filters) => dispatch(filterAction(filters)),
  getInvoicePdf: (id) => dispatch(getInvoiceAction(id)),
});

export default (connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentHistory));
